import type { AxiosInstance } from 'axios'
import axios from '@/axios'
import type { IGeofenceData, IGeofenceCircleData, IGeofencePolygonData } from '@/models/geofencing'
import type { IGeofencingService } from './geofencing.types'

export class GeofencingService implements IGeofencingService {
  private endpoint: string

  constructor(private axios: AxiosInstance) {
    this.endpoint = 'v1/geofencing/sites/'
  }

  fetchGeofences(siteCode: number): Promise<IGeofenceData[]> {
    return this.axios
      .get(`${this.endpoint}${siteCode}/geofences/`)
      .then(({ data }) => data)
  }

  fetchGeofence(siteCode: number, id: number): Promise<IGeofenceData> {
    return this.axios
      .get(`${this.endpoint}${siteCode}/geofences/${id}/`)
      .then(({ data }) => data)
  }

  createGeofence(siteCode: number, payload: IGeofenceCircleData | IGeofencePolygonData): Promise<IGeofenceData> {
    return this.axios
      .post(`${this.endpoint}${siteCode}/geofences/`, payload)
      .then(({ data }) => data)
  }

  updateGeofence(
    siteCode: number,
    id: number,
    payload: IGeofenceCircleData | IGeofencePolygonData
  ): Promise<IGeofenceData> {
    return this.axios
      .patch(`${this.endpoint}${siteCode}/geofences/${id}/`, payload)
      .then(({ data }) => data)
  }

  deleteGeofence(siteCode: number, id: number): Promise<void> {
    return this.axios
      .delete(`${this.endpoint}${siteCode}/geofences/${id}/`)
      .then(() => undefined)
  }
}

const geofencingService = new GeofencingService(axios)
export default geofencingService
